import N8nAvatar from './Avatar.vue';

export default N8nAvatar;
